module.exports = __webpack_public_path__ + "static/media/dot.e9e91ce4.png";